import { firebase } from "../firebase";

export const updatePhoneConfigStatus = async (
  accountId: string,
  newStatus: string,
  oldStatus: string,
  reason: string,
  sendEmail: boolean,
) => {
  try {
    const currentUser = firebase.auth().currentUser;
    const token = await currentUser?.getIdToken(true);

    const body = {
      accountId,
      newStatus,
      oldStatus,
      reason,
      sendEmail,
    };

    const response = await fetch(`cs/updatePhoneConfigStatus`, {
      body: JSON.stringify(body),
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accepts: "application/json",
      },
    });

    const data = await response.json();
    if (!response.ok || (response.status > 200 && response.status < 600)) {
      throw new Error(data.error || response.statusText);
    }

    return true;
  } catch (error) {
    console.error("Error updating phone config status:", error);
    throw error;
  }
};
